import React, { createContext, useContext, useState, useEffect } from 'react';
import portalApi from '../services/portalApi';

const PortalContext = createContext();

export const usePortalContext = () => {
  const context = useContext(PortalContext);
  if (!context) {
    throw new Error('usePortalContext must be used within PortalProvider');
  }
  return context;
};

export const PortalProvider = ({ children }) => {
  const [customer, setCustomer] = useState(null);
  const [business, setBusiness] = useState(null);  // NEW: Store business branding
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Load session from sessionStorage on mount
  useEffect(() => {
    const savedToken = sessionStorage.getItem('portalToken');
    const savedCustomer = sessionStorage.getItem('portalCustomer');
    const savedBusiness = sessionStorage.getItem('portalBusiness');  // NEW
    
    if (savedToken && savedCustomer) {
      setToken(savedToken);
      setCustomer(JSON.parse(savedCustomer));
      if (savedBusiness) {
        setBusiness(JSON.parse(savedBusiness));  // NEW
      }
    }
    
    setLoading(false);
  }, []);

  const login = async (accessToken) => {
    try {
      setLoading(true);
      setError(null);
      
      const data = await portalApi.validateToken(accessToken);
      
      setCustomer(data.customer);
      setBusiness(data.business || null);  // NEW
      setToken(data.sessionToken);
      
      // Save to sessionStorage
      sessionStorage.setItem('portalToken', data.sessionToken);
      sessionStorage.setItem('portalCustomer', JSON.stringify(data.customer));
      if (data.business) {
        sessionStorage.setItem('portalBusiness', JSON.stringify(data.business));  // NEW
      }
      
      return true;
    } catch (err) {
      console.error('Portal login error:', err);
      setError(err.response?.data?.message || 'Invalid or expired link');
      return false;
    } finally {
      setLoading(false);
    }
  };

  const logout = () => {
    setCustomer(null);
    setBusiness(null);  // NEW
    setToken(null);
    sessionStorage.removeItem('portalToken');
    sessionStorage.removeItem('portalCustomer');
    sessionStorage.removeItem('portalBusiness');  // NEW
  };

  const isAuthenticated = () => {
    return !!customer && !!token;
  };

  return (
    <PortalContext.Provider
      value={{
        customer,
        business,  // NEW: Expose business to consumers
        token,
        loading,
        error,
        login,
        logout,
        isAuthenticated
      }}
    >
      {children}
    </PortalContext.Provider>
  );
};